import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=0f9ef042&"
import script from "./UserCards.vue?vue&type=script&lang=js&"
export * from "./UserCards.vue?vue&type=script&lang=js&"
import style0 from "./UserCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports